import React from 'react';
import Image from 'next/image';
import VisibilitySensor from 'react-visibility-sensor';

import ChatBox from './ChatBox';
import styles from './Slack.module.css';

const defaultChats = [
  {
    id: 1,
    delay: 1750,
    textSizes: ['120px', '250px']
  }
];

export default class SlackSVG extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderAnimation: false,
      translate: 0,
      chats: [...defaultChats]
    };
  }

  handleVisibilityChange = isVisible => {
    const { renderAnimation } = this.state;
    if (!isVisible && renderAnimation) {
      this.setState({
        renderAnimation: false,
        translate: 0,
        chats: [...defaultChats]
      });
    }

    if (isVisible && !renderAnimation) {
      this.setState(
        {
          translate: 0,
          chats: [...defaultChats]
        },
        () => this.setState({ renderAnimation: true })
      );
    }
  };

  addNewChat = id => {
    const { chats, translate } = this.state;
    const newChat = {
      id: id + 1,
      delay: 1750,
      textSizes: [
        `${Math.floor(Math.random() * (300 - 100 + 1)) + 100}px`,
        `${Math.floor(Math.random() * (300 - 100 + 1)) + 100}px`
      ]
    };
    chats.push(newChat);
    let newTranslate = translate;
    if (id > 3) newTranslate = translate + 72;
    this.setState({ chats, translate: newTranslate });
  };

  render() {
    const { renderAnimation, chats, translate } = this.state;
    return (
      <VisibilitySensor onChange={this.handleVisibilityChange} partialVisibility>
        <div className="relative overflow-hidden rounded-lg shadow-2xl" style={{ minHeight: 365 }}>
          <div className="hidden xl:block">
            <Image
              layout="responsive"
              width={576}
              height={427}
              src="/static/images/sections/enterprise-ready/slack-desktop.png"
              alt="Slack chat service"
              unoptimized
            />
          </div>
          <div className="absolute block xl:hidden">
            <Image
              layout="fixed"
              width={730}
              height={365}
              src="/static/images/sections/enterprise-ready/slack-mobile.png"
              alt="Slack chat service"
              unoptimized
            />
          </div>
          {renderAnimation && (
            <div className={`${styles.viewport} transform translate-y-4 xl:translate-y-8 absolute z-10 overflow-hidden`}>
              <div
                className={styles.content}
                style={{ transform: `translate3d(0, -${translate}px, 0)` }}
              >
                {chats.map(e => (
                  <ChatBox
                    key={`chatbox-${e.id}`}
                    id={e.id}
                    delay={e.delay}
                    textSizes={e.textSizes}
                    addNewChat={this.addNewChat}
                    limit={18}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </VisibilitySensor>
    );
  }
}
